import {
  useFetchMemberRoles,
  useFetchMemberSelf,
} from "src/data/organizations/queries/memberQueries"

export function useCanCreateTask({ orgId }: { orgId: string }) {
  const { data: member } = useFetchMemberSelf({
    orgId: orgId,
  })

  const memberId = member?.member_id ?? ""

  const {
    data: memberRoles,
    error,
    isLoading,
  } = useFetchMemberRoles(
    {
      memberId: memberId,
      orgId: orgId,
      accessRoles: ["admin", "owner", "responder", "member"],
    },
    {
      enabled: memberId.length > 0,
    }
  )

  //TODO: GXP-1220 Remove when backend is released
  const memberRolesNotFound = error?.status === 404

  // If the user has a role > operator on any resource, they can create tasks
  const canCreateTask =
    (memberRoles?.paging?.total_count ?? 0) > 0 || memberRolesNotFound

  return {
    canCreateTask,
    loadingMemberRoles: isLoading,
  }
}
